import IDate, { NewDate } from "../Date";
import Religion from "../enums/Religion";

interface ISpouse {
    name: string;
    birthDate: IDate;
    job: string;
    marriageDate: IDate;
    fatherName: string;
    motherName: string;
    religion: Religion;
}

export const NewSpouse: ISpouse = {
    name: "",
    birthDate: NewDate,
    job: "",
    marriageDate: NewDate,
    fatherName: "",
    motherName: "",
    religion: Religion.REFORMED
};

export default ISpouse;
